// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'shapes';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M3.156 1.031h11.688s2.125 0 2.125 2.125v11.688s0 2.125-2.125 2.125H3.156s-2.125 0-2.125-2.125V3.156s0-2.125 2.125-2.125z' />
    <path d='M8.004 5.442A1.063 1.063 0 0 1 9 4.75h4.25a1.063 1.063 0 0 1 1.063 1.063v4.25a1.062 1.062 0 0 1-1.063 1.062h-1.063m-2.124-.531a3.187 3.187 0 1 1-3.188-3.188m1.79.55c.36.244.667.558.902.925' />
  </g>
);

export const viewBox = '0 0 18 18';
